import stringSimilarity from "string-similarity"

export const SCHEDULE_SEARCH_STRONG_MATCH_SCORE = 0.9
export const SCHEDULE_SEARCH_RESULT_THRESHOLD = 0.2
export const SCHEDULE_SEARCH_SUBSTRING_MIN_LENGTH = 2

export function getScheduleSearchScore(search, schedule) {
    const query = normaliseScheduleSearchText(search)
    if (!query) return 0

    return Math.max(scoreLabel(schedule?.label, query), scoreCode(schedule?.code, query))
}

export function normaliseScheduleSearchText(value) {
    return `${value ?? ""}`
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim()
}

function scoreLabel(label, query) {
    const normalisedLabel = normaliseScheduleSearchText(label)
    if (!normalisedLabel) return 0
    if (normalisedLabel.startsWith(query)) return SCHEDULE_SEARCH_STRONG_MATCH_SCORE
    if (isStrongSubstringMatch(normalisedLabel, query)) return SCHEDULE_SEARCH_STRONG_MATCH_SCORE
    return stringSimilarity.compareTwoStrings(query, normalisedLabel)
}

function scoreCode(code, query) {
    const normalisedCode = normaliseScheduleSearchText(code)
    if (!normalisedCode) return 0
    if (normalisedCode.startsWith(query)) return SCHEDULE_SEARCH_STRONG_MATCH_SCORE
    if (isStrongSubstringMatch(normalisedCode, query)) return SCHEDULE_SEARCH_STRONG_MATCH_SCORE
    return stringSimilarity.compareTwoStrings(query, normalisedCode)
}

function isStrongSubstringMatch(value, query) {
    return query.length >= SCHEDULE_SEARCH_SUBSTRING_MIN_LENGTH && value.includes(query)
}
